import React, { useEffect, useState } from 'react'
import styles from "./ServiceCardSlice.module.css"
import { ServiceCardSliceDataType } from '../../interfaces/serviceCardSlice/serviceCardSlice'
import {
    getGeneralImage, generateStyleClasses,
    styleHelper,
} from '../../helpers/commonFunctions'
import useComponentsStore from '../../store/componentsStateStore'
import { logOrderProductsClickAddCart } from '../../membership/logging/helpers/commonLoggingFunctions'

const ServiceCardSlice = ({ items }: { items: ServiceCardSliceDataType[] }) => {
    const action = items[0]?.actionSelect;

    const [isMobile, setIsMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {
        continueDraft,
        isSelectingPayPerListing,
        setIsSelectingPayPerListing,
    } = useComponentsStore();

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            const isMobileDevice = screenWidth <= 572; // Adjust the threshold value as needed

            setIsMobile(isMobileDevice);
        };

        // Attach the resize event listener
        window.addEventListener("resize", handleResize);

        // Check initial screen width on component mount
        handleResize();

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const onClickHandler = async () => {
        if (isLoading || isSelectingPayPerListing) return;
        try {
            logOrderProductsClickAddCart();
            setIsSelectingPayPerListing(true);
            setIsLoading(true);
            await continueDraft(action.payload);
        } catch (err) {
            console.error(err);
        } finally {
            setIsSelectingPayPerListing(false);
            setIsLoading(false);
        }
    };

    return (
        <div className='vas-pb-2 pointerCursor'>
            <div className={`vas-px-2 vas-ms-sm-2`}>
                <div className={`vas-card vas-d-flex vas-justify-content-between vas-w-100 ${!isMobile ? "vas-mb-3 " : "vas-mb-1"} ${!isMobile ? "vas-mt-2 " : "vas-mt-4"} ${!isMobile ? "vas-p-2" : "vas-p-1"} ${styles.card_borders}`} onClick={onClickHandler}>
                    <div className={`vas-flex-column .vas-gap-0 vas-p-2 vas-pt-3`}>
                        {items[0]?.topPills && items[0]?.topPills.length > 0 && (
                            <div className={`vas-d-flex vas-align-items-canter vas-position-absolute ${styles.consumer_tag_container}`}>
                                {items[0]?.topPills.map((topPill, idx) => {
                                    return (
                                        <div
                                            key={idx}
                                            className={`vas-px-2 vas-text-center vas-fw-bold vas-border-radius vas-text-14 ${styles.consumer_tag} ${generateStyleClasses(
                                                topPill?.style
                                            )} ${!idx ? "vas-mx-2" : "vas-mx-1"}`}
                                            style={styleHelper({
                                                color: topPill?.textColor ?? "",
                                                backgroundColor: topPill?.backgroundColor,
                                                border: topPill ? `1px solid ${topPill?.borderColor}` : "0px",
                                            })}
                                        >
                                            {topPill?.text ?? ""}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                        <div className="vas-d-flex vas-gap-2 vas-align-items-start">
                            <div>
                                {isLoading ?

                                    (<i className={`vas-spinner-border vas-text-success vas-spinner-border-sm vas-my-1 vas-mx-1 ${styles.loader_size}`}
                                    />)
                                    :
                                    (<img
                                        src={getGeneralImage(items[0].icon)}
                                        alt=""
                                        width={30}
                                        height={30}
                                    />)
                                }

                            </div>

                            <div className={`vas-d-flex vas-flex-column vas-align-items-start `}>
                                <span className={` ${!isMobile ? styles.title_font_size : styles.title_font_size_small} ${styles.title_font_weight}`}>{items[0].title.text}</span>
                                {isMobile && (<span
                                    className={`${generateStyleClasses(
                                        items[0]?.unitPrice?.style
                                    )} vas-text-15 ${styles.title_font_weight_mobile}`}
                                    style={styleHelper({ color: items[0]?.unitPrice?.textColor })}
                                >
                                    {items[0]?.unitPrice?.text}
                                </span>)}

                            </div>

                        </div>

                        <div
                            style={{
                                ...styleHelper({
                                    color: items[0]?.subtitle?.textColor ?? "",
                                    fontSize: items[0]?.subtitle?.style.size,
                                }),
                                visibility: items[0]?.subtitle?.text ? "visible" : "hidden",
                            }}
                            className={`${styles.subtitle_margin} ${styles.subtitle_font} vas-mx-5`}
                        >
                            {items[0]?.subtitle?.text || "."}
                        </div>


                    </div>
                    <div className={`vas-d-flex vas-flex-column ${!isMobile ? "vas-p-2" : "vas-pt-4 vas-p-1"}  vas-gap-1 vas-align-items-end`}>
                        {items[0]?.strikeThroughTotalPrice && (
                            <span
                                className={`${generateStyleClasses(items[0]?.strikeThroughTotalPrice?.style)} vas-text-decoration-line-through vas-text-13 vas-mx-1`}
                                style={styleHelper({ color: items[0]?.strikeThroughTotalPrice.textColor})}
                            // style={styleHelper({
                            //     color: items[0]?.strikeThroughTotalPrice.textColor,
                            // })}
                            >
                                {items[0]?.strikeThroughTotalPrice?.text}

                            </span>
                        )}
                        {items[0]?.totalPrice && (
                            <span
                                className={`${generateStyleClasses(
                                    items[0]?.totalPrice?.style
                                )} vas-text-12`}
                                style={styleHelper({ color: items[0]?.totalPrice?.textColor })}
                            >
                                {items[0]?.totalPrice?.text}
                            </span>
                        )}
                        {!isMobile && (<span
                            className={`${generateStyleClasses(
                                items[0]?.unitPrice?.style
                            )} vas-text-16 ${styles.title_font_weight}`}
                            style={styleHelper({ color: items[0]?.unitPrice?.textColor })}
                        >
                            {items[0]?.unitPrice?.text}
                        </span>)}

                    </div>
                </div>
            </div>
        </div>


    )
}

export default ServiceCardSlice
